import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "./_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useDeviceModelsStore = defineStore('deviceModels', {
    state: () => ({
        data: undefined,
        options: undefined,
    }),
    getters: {
        getDeviceModels: (state) => state.data?.data,
        getDeviceModelOptions: (state) => state.options?.data,
    },
    actions: {
        /**
         * This method should be used to return as little data as possible for use in select boxes
         *
         * @param params
         * @param silent
         * @returns {Promise<any>}
         */
        async indexDeviceModelOptions(params = {}, silent = true) {

            if (!silent)
                this.options = undefined;

            try {
                if (!this.options) {
                    let qryParams = mergeOptionsParams(params, 'device_models', ['id', 'name', 'company_id', 'device_type_id', 'device_manufacturer_id']);
                    const response = await axios.get('device-models', {params: qryParams});
                    this.options = response.data;
                }

                return this.options;
            } catch (error) {
                console.error(error.response);
                throw error.response;
            }
        },
        async indexDeviceModels(params = {}) {
            try {
                const response = await axios.get('device-models', {params} );
                this.data = response.data;
            } catch (error) {
                console.error(error.response);
                throw error.response;
            }
        },
        async createDeviceModel(params = {}) {
            try {
                const response = await axios.get('device-models/create', {params} );
                return useCreateForm(`device-models`, response.data, { onFinish: () => this.options = undefined });
            } catch (error) {
                console.error(error.response);
                throw error.response;
            }
        },
        async showDeviceModel( deviceModelId, params = {}) {
            try {
                const response = await axios.get(`device-models/${deviceModelId}`, {params} );
                return response.data;
            } catch (error) {
                console.error(error.response);
                throw error.response;
            }
        },
        async editDeviceModel( deviceModelId, params = {}) {
            try {
                const response = await axios.get(`device-models/${deviceModelId}/edit`, {params} );
                return useEditForm(`device-models/${deviceModelId}`, response.data, { onFinish: () => this.options = undefined });
            } catch (error) {
                console.error(error.response);
                throw error.response;
            }
        },
        async deleteDeviceModel( deviceModelId, params = {}) {
            try {
                const response = await axios.delete(`device-models/${deviceModelId}`, {params} );
                this.options = undefined;
                toasteventbus.emit('add', {
                    summary: 'Device Model Deleted',
                    detail: `Device Model has been deleted.`,
                    severity: 'success',
                    life: 3000
                });

            } catch (error) {
                console.error(error.response);
                throw error.response;
            }
        },
    },
});
